document.addEventListener("DOMContentLoaded", () => {
    if (!window.location.pathname.includes('/pages/blogs') && !window.location.pathname.includes('/pages/noticias')) {
        return
    }

    let openButton = document.querySelector('.open-blog-filters')
    if (!openButton) return

    let filtersContainer = document.querySelector('.blog-filters__content')
    if (!filtersContainer) return

    openButton.addEventListener('click', () => filtersContainer.classList.toggle('open'))

    if (window.location.pathname.includes('/pages/blogs-filtered')) showArticlesFiltered()
})

const showArticlesFiltered = () => {
    let title = document.querySelector(".title--primary")
    if (!title) return

    let text = window.location.search.split("?tag=")[1]
    if (!text) {
        title.innerText = 'Blogs'
        return
    }
    text = text.charAt(0).toUpperCase() + text.slice(1).replaceAll("-", " ")
    title.innerText = text

    let articles = [...document.querySelectorAll(".article_item")]
    if (articles.length === 0) return

    articles.forEach(article => {
        let tags = article.dataset.tag.split("_").filter(tag => {
            if (tag !== "") return tag
        })

        let hasTag = false
        tags.forEach(tag => {
            if (tag.toLowerCase().replaceAll(" ", "-") === window.location.search.split("?tag=")[1]) {
                hasTag = true
            }
        })

        if (!hasTag) article.parentElement.removeChild(article)
    })

    articles = [...document.querySelectorAll(".article_item")]
    if (articles.length === 0) return

    articles[0].classList.add("item_only")
    articles[0].classList.remove("item_third")
}
